<template>
  <div>
    <div class="ratio ratio-16x9" ref="videoContainer">
      <div v-if="spinner" class="d-flex justify-content-center align-items-center w-100 h-100" style="z-index: -1">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import playerjs from 'player.js'

export default {
  props: ['component'],
  data: () => ({
    player: null,
    spinner: 1,
    milestones: [10, 25, 50, 75, 90],
    milestonesReached: [],
    milestonesSet: false, 
  }),
  mounted() {
    if (this.bunny) {
      const p = this.createVideoIframe()
      this.player = new playerjs.Player(p)

      this.player.on('ready', () => {
        this.setPlayerEvents()
      })

      const stored = this.getStoredMilestone(this.component.bunny_id)
      if (stored > 0) {
        this.milestonesReached = this.milestones.filter((m) => m <= stored)
      }
    }
  },
  destroyed() {
    if (this.player) {
      this.disablePlayerEvents()
    }
  },
  computed: {
    bunny() {
      if (this.component.bunny_id && _.includes([3, 4], this.component.bunny_status)) {
        return true
      }
      return false
    },
  },
  methods: {
    createVideoIframe() {
      const iframe = document.createElement('iframe')
      iframe.src = `https://player.mediadelivery.net/embed/25534/${this.component.bunny_id}?autoplay=false&preload=false&muted=false&rememberPosition=true`
      iframe.setAttribute('loading', 'lazy')
      iframe.setAttribute('allow', 'accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;')
      iframe.setAttribute('allowfullscreen', true)
      this.$refs.videoContainer.appendChild(iframe)
      this.spinner = 0
      return iframe
    },
    setPlayerEvents() {
      this.player.on('play', this.handlePlayEvent)
      this.player.on('timeupdate', this.handleTimeUpdate) // Listen for time updates
    },
    setMilestones() {
      this.player.getDuration((duration) => {
        if (duration < 60) {
          this.milestones = [90]
        } else if (duration > 1800) {
          this.milestones = [10, 20, 30, 40, 50, 60, 70, 80, 90]
        }
      })
    },
    handlePlayEvent() {},
    handleTimeUpdate(event) {
      const currentTime = event.seconds
      const duration = event.duration

      if (!this.milestonesSet && duration > 0) {
        this.setMilestones(duration)  // pass duration directly
        this.milestonesSet = true
      }

      const percentageWatched = (currentTime / duration) * 100

      this.milestones.forEach((milestone) => {
        if (percentageWatched >= milestone && !this.milestonesReached.includes(milestone)) {
          this.milestonesReached.push(milestone)
          this.sendMilestone(milestone)
        }
      })
    },
    sendMilestone(milestone) {
      if (['skyier.test', 'skyier.com'].includes(window.location.host)) return

      const key = `video_milestone_${this.component.bunny_id}`
      const stored = parseInt(localStorage.getItem(key)) || 0
      if (milestone <= stored) return

      this.setStoredMilestone(this.component.bunny_id, milestone)

      axios
        .post('/json/video/usage', {
          bunny_id: this.component.bunny_id,
          component_id: this.component.id,
          milestone: milestone,
        })
        .catch(() => {})
    },
    disablePlayerEvents() {
      this.player.off('play')
      this.player.off('timeupdate')
    },
    getStoredMilestone(bunnyId) {
      try {
        return parseInt(localStorage.getItem(`video_milestone_${bunnyId}`)) || 0
      } catch (e) {
        return 0
      }
    },
    setStoredMilestone(bunnyId, milestone) {
      try {
        localStorage.setItem(`video_milestone_${bunnyId}`, milestone)
      } catch (e) {}
    },
  },
}
</script>
